//★★フロントエンド設定の内容が固まったら、IndexCoreに入れて、APIで呼び出しする
export const appInitialize = {
  indexAppCd: 'bizMarche',
  frontendCd: 'welcomeAppInitialize',
  items: {
    layout: {
      header: {
        label: '',
        title: 'Biz-Marche',
        titleLink: 'https://prototype-dashboard-ui.backend.out.nakamenosakura.com',
        subTitle: 'Welcome',
        subTitleLink: 'welcome',
        subTitleColor: '#40d199',
      },
      menu: [],
    },
  },
}
